import { Amplify } from "aws-amplify";
import awsconfig from "../aws-exports";

export type AuthCognitoPool = "member" | "measureOperator";

/**
 * Switches Amplify between the member (community) user pool and the dedicated operator pool.
 * Call on auth screens before any `Auth.*` usage for that pool.
 */
export const configureAmplifyPool = (pool: AuthCognitoPool) => {
  if (pool === "member") {
    Amplify.configure(awsconfig);
    return;
  }

  const poolId = import.meta.env.VITE_MEASURE_OPERATOR_COGNITO_USER_POOL_ID as string | undefined;
  const webClientId = import.meta.env.VITE_MEASURE_OPERATOR_COGNITO_USER_POOL_WEB_ID as string | undefined;

  if (!poolId?.trim() || !webClientId?.trim()) {
    throw new Error(
      "Missing VITE_MEASURE_OPERATOR_COGNITO_USER_POOL_ID or VITE_MEASURE_OPERATOR_COGNITO_USER_POOL_WEB_ID"
    );
  }

  Amplify.configure({
    ...awsconfig,
    aws_user_pools_id: poolId,
    aws_user_pools_web_client_id: webClientId,
  });
};
